module.exports = __webpack_public_path__ + "static/PieBeatsCake-white-gt-printaura3-7c5a6bcdc3c995f47513024a4741f3e4.png";